import { render, staticRenderFns } from "./MultiSelectGuardiao.vue?vue&type=template&id=520c6d0d"
import script from "./MultiSelectGuardiao.vue?vue&type=script&lang=js"
export * from "./MultiSelectGuardiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports